
// import React from "react";
// import { Carousel } from "react-bootstrap";
// import sliderImg from "../../assets/images/slider/image1.jpg";
// import sliderImg1 from "../../assets/images/slider/image4.jpg";
// import sliderImg3 from "../../assets/images/slider/image3.jpg";

// import "../Banner/banner.css";

// const Banner = () => {
//   return (
//     <>
//       <section className="slider">
//         <Carousel variant="dark">
//           {/* Slide 1 */}
//           <Carousel.Item>
//             <img
//               src={sliderImg3}
//               className="d-block w-100"
//               alt="Rann of Kutch, Gujarat"
//               loading="eager"
//             />
//             <Carousel.Caption>
//               <div className="slider_des">
//                 <h5 className="heading">
//                   DISCOVER <span>Rann of Kutch</span>
//                 </h5>
//                 <p className="sub_text">
//                   Experience the White Desert Festival, folk dances, and the breathtaking landscapes of the Rann of Kutch.
//                 </p>
//               </div>
//             </Carousel.Caption>
//           </Carousel.Item>

//           {/* Slide 2 */}
//           <Carousel.Item>
//             <img
//               src={sliderImg}
//               className="d-block w-100"
//               alt="Somnath Temple, Gujarat"
//               loading="eager"
//             />
//             <Carousel.Caption>
//               <div className="slider_des">
//                 <h5 className="heading">
//                   EXPLORE <span>Somnath Temple</span>
//                 </h5>
//                 <p className="sub_text">
//                   Visit Gujarat’s spiritual pride — the first Jyotirlinga of Lord Shiva with a rich history and divine aura.
//                 </p>
//               </div>
//             </Carousel.Caption>
//           </Carousel.Item>

//           {/* Slide 3 */}
//           <Carousel.Item>
//             <img
//               src={sliderImg1}
//               className="d-block w-100"
//               alt="Gir National Park, Gujarat"
//               loading="lazy"
//             />
//             <Carousel.Caption>
//               <div className="slider_des">
//                 <h5 className="heading">
//                   WILDLIFE <span>Gir National Park</span>
//                 </h5>
//                 <p className="sub_text">
//                   Witness the majestic Asiatic Lions and explore Gujarat’s incredible biodiversity in its natural habitat.
//                 </p>
//               </div>
//             </Carousel.Caption>
//           </Carousel.Item>
//         </Carousel>
//       </section>
//     </>
//   );
// };

// export default Banner;
import React from "react";
import { Carousel } from "react-bootstrap";
import sliderImg from "../../assets/images/slider/image1.jpg";
import sliderImg1 from "../../assets/images/slider/image4.jpg";
import sliderImg3 from "../../assets/images/slider/image3.jpg";

import "../Banner/banner.css";

const Banner = () => {
  return (
    <section className="slider">

      <Carousel fade interval={4000}>
        {/* Slide 1 */}
        <Carousel.Item>
          <img src={sliderImg3} alt="Rann of Kutch" />
          <Carousel.Caption>
            <div className="jadoo-content">
              <span className="tagline">BEST DESTINATIONS IN GUJARAT</span>
              <h1>
                Discover <span>Rann of Kutch</span>
              </h1>
              <p>
                Experience the White Desert Festival, folk dances and stunning
                landscapes.
              </p>

              {/* <div className="hero-actions">
                <button className="primary-btn">Find out more</button>
                <button className="play-btn">
                  <span>▶</span> Play Demo
                </button>
              </div> */}
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 2 */}
        <Carousel.Item>
          <img src={sliderImg} alt="Somnath Temple" />
          <Carousel.Caption>
            <div className="jadoo-content">
              <span className="tagline">SPIRITUAL DESTINATION</span>
              <h1>
                Explore <span>Somnath Temple</span>
              </h1>
              <p>
                Gujarat’s spiritual pride — the first Jyotirlinga of Lord Shiva.
              </p>

              {/* <div className="hero-actions">
                <button className="primary-btn">Explore Now</button>
              </div> */}
            </div>
          </Carousel.Caption>
        </Carousel.Item>

        {/* Slide 3 */}
        <Carousel.Item>
          <img src={sliderImg1} alt="Gir National Park" />
          <Carousel.Caption>
            <div className="jadoo-content">
              <span className="tagline">WILDLIFE EXPERIENCE</span>
              <h1>
                Wildlife <span>Gir Forest</span>
              </h1>
              <p>
                Witness the majestic Asiatic Lions in their natural habitat.
              </p>

              {/* <div className="hero-actions">
                <button className="primary-btn">Book Safari</button>
              </div> */}
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </section>
  );
};

export default Banner;
